import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CuestionariosSaludComponent } from './components/cuestionarios-salud.component';

export const routes: Routes = [
  {
    path: 'cuestionarios-salud.html',
    component: CuestionariosSaludComponent
  },
  {
    path: 'cuestionarios-salud',
    component: CuestionariosSaludComponent
  },
  {
    path: '',
    component: CuestionariosSaludComponent
  }
];

@NgModule({
  declarations: [],
  imports: [[RouterModule.forChild(routes)]],
  exports: [RouterModule]
})
export class CuestionariosSaludRoutingModule {}
